export default {
	namespaced: true,
	state: () => ({
		leavePageTime: 0, // 标记签到弹窗分享按钮分享时间戳
		leaveTimer: null, // 奖励发放控制计时器
		leaveRewardTime: 5000, // 发放奖励时长限制

		// 主活动数据
		mainActData: {
			actRemainTime: 0, // 主活动持续时间
		},

		// 邀请码填写跳转标记
		isJumpToEditCode: false,
		// 邀请码
		inviteCode: '',

		// 裂变页弹窗数据
		modalData: {},

		// 提现页数据
		weChatVerifyAB: 'a', // 微信提现实名认证 ab
		userInfo: {}, // 提现用户信息

		// 裂变页版本 ab
		fissionPageAB: null,

		//  特殊奖励倒计时
		specialPriceCountDown: '',
		newFissionPageShowAb: '',
		fissionPageShowV5Ab: '',
		shareTipsInfo: {},
		fissionNewUserAb: 'a',
	}),
	mutations: {
		setLeaveTime(state, data) {
			state.leavePageTime = data;
		},
		setActRemainTime(state, data) {
			state.mainActData.actRemainTime = data;
		},
		setJumpToEditCode(state, data) {
			state.isJumpToEditCode = data;
		},
		setInviteCode(state, data) {
			state.inviteCode = data;
		},
		setModalData(state, data) {
			state.modalData = data;
		},
		setWithdrawCommInfo(state, data) {
			const { weChatVerifyAB, userInfo } = data;

			state.weChatVerifyAB = weChatVerifyAB || 'a';
			userInfo && Object.assign(state.userInfo, userInfo);
		},
		setFissionPageAB(state, data) {
			state.fissionPageAB = data;
		},
		setSpecialPriceCountDown(state, data) {
			state.specialPriceCountDown = data;
		},
		setNewFissionPageShowAb(state, data) {
			state.newFissionPageShowAb = data;
		},
		setFissionPageShowV5Ab(state, data) {
			state.fissionPageShowV5Ab = data;
		},
		setShareTipsInfo(state, data) {
			state.shareTipsInfo = data;
		},
		setFissionNewUserAb(state, data) {
			state.fissionNewUserAb = data;
		},
	},
	actions: {},
	getters: {
		leavePageTime: (state) => {
			return state.leavePageTime;
		},
		leaveRewardTime: (state) => {
			return state.leaveRewardTime;
		},
		actRemainTime: (state) => {
			return state.mainActData.actRemainTime;
		},
		inviteCode: (state) => {
			return state.inviteCode;
		},
		modalData: (state) => {
			return state.modalData;
		},
		verifyAB: (state) => {
			return state.weChatVerifyAB;
		},
		userInfo: (state) => {
			return state.userInfo;
		},
		fissionPageAB: (state) => {
			return state.fissionPageAB;
		},
		isJumpToEditCode: (state) => {
			return state.isJumpToEditCode;
		},
		specialPriceCountDown: (state) => {
			return state.specialPriceCountDown;
		},
		newFissionPageShowAb: (state) => {
			return state.newFissionPageShowAb;
		},
		fissionPageShowV5Ab: (state) => {
			return state.fissionPageShowV5Ab;
		},
		shareTipsInfo: (state) => {
			return state.shareTipsInfo;
		},
		fissionNewUserAb: (state) => {
			return state.fissionNewUserAb;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/Fission/v3.js